import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Document Booking',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Document Booking',
        href: '/opc/doc/booking',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    filter: null,
    is_repo: false,
    date_filter: false,
    filterOn: [],
    sortBy: 'id_container_stock',
    sortDesc: true,
    fields: [
      {
        key: 'code_booking',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'Book No',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'shipper',
        label: 'Shipper',
      },
      {
        key: 'doc_type',
        label: 'Type',
      },
      {
        key: 'jenis',
        label: 'Jenis',
        sortable: true,
      },
      {
        key: 'vessel_voy',
        label: 'vessel/voy',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    items_container_stock: [],
    fields_container_stock: [
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
        sortable: true,
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'date_in',
        label: 'Date In',
        sortable: true,
      },
      {
        key: 'condition',
        label: 'Condition',
        sortable: true,
      },
      {
        key: 'location',
        label: 'Location',
        sortable: true,
      },
      {
        key: 'date_manufacture',
        label: 'Date Mnf',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      code_principle: '',
      doc_no: '',
      doc_type: '',
      booking_date: '',
      shipper_name: '',
      shipper_code: '',
      shipper_group: '',
      type_booking: 'realtime',
      vessel: '',
      commodity: '',
      port_of_discharge: '',
      imo_class: '',
      imo_un: '',
      trucking_code: '',
      trucking_name: '',
      cont_to: '',
      repotition: false,
      is_trucking_dkm: 0,
      containers: [],
      pic_name: '',
      pic_contact: '',
      pic_photo: [],
    },
    doc_type_filter: '',
    status_filter: '',
    kartumuat: false,
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  kartumuat(state) {
    return state.data.kartumuat;
  },
};

export const mutations = {
  changeBooking(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getBookingPayment({ commit }, payload = null) {
    commit('changeBooking', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/payment-booking/search`, payload);
    commit('changeBooking', {
      loading: false,
    });

    if (!result.error) {
      return result.data.object || [];
    }

    return [];
  },

  async getShipperGroup({ commit, state }, payload = null) {
    commit('changeBooking', {
      loading: true,
    });
    const { data } = state;
    let result = await ApiGetRequest(
      `opr/principles/${
        payload ? payload.id : data.form.id_principle
      }/consignee-group?doc_type=${
        data.form && data.form.doc_type ? data.form.doc_type : ''
      }`
    );

    if (!result.error) {
      commit('changeBooking', {
        loading: false,
        items_shipper_group: result.data.object,
      });

      return result.data.object;
    }

    commit('changeBooking', {
      items_shipper_group: [],
      loading: false,
    });

    return false;
  },

  async getListBooking({ commit, state }) {
    commit('changeBooking', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      is_repo: data.is_repo ? 1 : 0,
    };

    if (data.date_filter && data.date_filter.length > 0) {
      params.start_date = data.date_filter[0]
        ? moment(data.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.date_filter[1]
        ? moment(data.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    if (data.doc_type_filter && data.doc_type_filter !== '') {
      params.doc_type = data.doc_type_filter;
    }

    if (data.status_filter && data.status_filter !== '') {
      params.status = data.status_filter;
    }

    let result = await ApiGetRequest(`opr/booking`, params);
    commit('changeBooking', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return result.error ? false : true;
  },

  async checkDocNumber({ commit, state, dispatch }) {
    commit('changeBooking', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/booking/check-doc-number`, {
      doc_no: data.form.doc_no ? data.form.doc_no : '',
    });

    if (result.data.object) {
      commit('changeBooking', {
        loading: false,
        form: {
          ...data.form,
          doc_no: '',
        },
      });

      showNotif(dispatch, {
        message: 'Booking No sudah terdaftar dalam sistem sebelumnya',
        type: 'error',
      });
    } else {
      commit('changeBooking', {
        loading: false,
      });
    }

    return result.error ? false : true;
  },

  async getDetailBooking({ commit, state }, payload = null) {
    commit('changeBooking', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/booking/${payload.id}`);
    commit('changeBooking', {
      loading: false,
    });

    if (!result.error) {
      commit('changeBooking', {
        form: {
          ...data.form,
          ...result.data.object,
        },
      });
    }

    return false;
  },

  async createBooking({ commit, state, dispatch }) {
    commit('changeBooking', {
      loading: true,
    });

    let form = state.data.form;
    let result = await ApiPostRequest(`opr/booking`, form);
    commit('changeBooking', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return !result.error ? true : false;
  },

  async updateBooking({ commit, state, dispatch }, payload = null) {
    commit('changeBooking', {
      loading: true,
    });

    let form = state.data.form;
    let result = await ApiPutRequest(`opr/booking/${payload.id}`, form);
    commit('changeBooking', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return !result.error ? true : false;
  },

  async deleteBooking({ commit, dispatch }, payload = null) {
    commit('changeBooking', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/booking/${payload.id}`);
    commit('changeBooking', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async undoDeleteBooking({ commit, dispatch }, payload = null) {
    commit('changeBooking', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/booking/undo-destroy/${payload.id}`);
    commit('changeBooking', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async uploadImagePIC({ commit, state }, payload) {
    commit('changeBooking', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/photo`, payload);
    commit('changeBooking', {
      loading: false,
    });

    if (!result.error) {
      let pic_photo = data.form.pic_photo || [];
      pic_photo.push(result.data.object);

      commit('changeBooking', {
        form: {
          ...data.form,
          pic_photo,
        },
      });
    }
  },

  async getContainerStock({ commit, state }) {
    commit('changeBooking', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      principle: data.form ? data.form.id_principle : '',
      booking: 1,
    };

    if (data.form.containers && data.form.containers.length > 0) {
      let dataCont = data.form.containers.map((item) => item.id_container);
      params.containers = dataCont.join(',');
    }

    let result = await ApiGetRequest(`opr/container/stock`, params);
    commit('changeBooking', {
      loading: false,
    });

    if (!result.error) {
      commit('changeBooking', {
        items_container_stock: !result.error ? result.data.object : [],
        total: result.data.total || 0,
      });

      return true;
    }

    return false;
  },

  async searchStock(context, params = null) {
    let result = await ApiGetRequest(`opr/container_stock`, params);
    return !result.error ? result.data.object : false;
  },

  async getPrintKartuMuat({ commit }, payload = null) {
    commit('changeBooking', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/booking/${payload.id}/kartu-muat`);
    commit('changeBooking', {
      loading: false,
    });

    if (!result.error) {
      commit('changeBooking', {
        kartumuat: !result.error ? result.data.object : false,
      });

      return true;
    }

    return false;
  },
};
